import React from "react";
import { Modal, Button } from "react-bootstrap";
import PropTypes from "prop-types";
import { GAME_TYPE_MODAL } from "behaviour-analyzer-shared";

const GameTypeModal = ({ isOpen, onClose, onSelectNewGame, onSelectContinue, modeTitle }) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>{GAME_TYPE_MODAL.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center text-muted mb-4">
          <strong>{GAME_TYPE_MODAL.modalityLabel}</strong> {modeTitle}
        </p>
        <div className="d-grid gap-3">
          <Button
            variant="primary"
            size="lg"
            onClick={onSelectContinue}
          >
            {GAME_TYPE_MODAL.continueButton}
          </Button>
          <Button
            variant="success"
            size="lg"
            onClick={onSelectNewGame}
          >
            {GAME_TYPE_MODAL.newGameButton}
          </Button>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {GAME_TYPE_MODAL.cancelButton}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

GameTypeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectNewGame: PropTypes.func.isRequired,
  onSelectContinue: PropTypes.func.isRequired,
  modeTitle: PropTypes.string.isRequired,
};

export default GameTypeModal;
